<template>
	<div class="inline-block">
		<a target="__blank" v-if="relationItemLink" :href="relationItemLink" class="item-relation">
			<cbs-relation-icon :type="relation.type" />
			<span class="item-relation__name item-relation--link text-solid-primary font-normal underline">{{ relation.display || relation.name }}</span>
		</a>
		<div v-else class="item-relation">
			<cbs-relation-icon :type="relation.type" />
			<span class="item-relation__name">{{ relation.display || relation.name }}</span>
		</div>
	</div>
</template>

<script>
export default {
	name: "DisplayItemRelation",
	props: {
		relation: {
			type: Object,
			validator: prop => prop.hasOwnProperty("id") && prop.hasOwnProperty("type") && (prop.hasOwnProperty("name") || prop.hasOwnProperty("display"))
		}
	},
	computed: {
		relationItemLink() {
			console.log("this.relation.type", this.relation.type);
			switch (this.relation.type) {
				case this.$constant.RELATION_MODELS.POST:
					return this.$constant.PAGES_PATH.PAGE_CBS_POST_PATH;
				case this.$constant.RELATION_MODELS.TODO:
					return `${this.$constant.PAGES_PATH.PAGE_CBS_TODO_PATH}?id=${this.relation.id}`;
				case this.$constant.RELATION_MODELS.REQUEST:
					return `${this.$constant.PAGES_PATH.PAGE_CBS_REQUEST_PATH}?id=${this.relation.id}`;
				case this.$constant.RELATION_MODELS.DEVICE:
					return `${this.$constant.PAGES_PATH.PAGE_CBS_DEVICE_PATH}?id=${this.relation.id}`;
				case this.$constant.RELATION_MODELS.PRODUCT:
					return `${this.$constant.PAGES_PATH.PAGE_CBS_CUSTOMER_LIST_PRODUCTS_PATH}?id=${this.relation.id}`;
				default:
					return "";
			}
		}
	}
};
</script>
<style lang="scss">
.item-relation {
	.item-relation__name {
		color: #000;
		&:hover {
			color: inherit;
		}
	}
}
</style>
